import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { environment } from '../../../../environments/environment';
import { BaseApiResponse } from '../../models/api/api.model';

export interface InfoPage {
  id: string;
  title: string;
  content: string;
  language: string;
  isActive: boolean;
  createdDate: string;
}

export interface GetAllInfoPagesResponse {
  infoPages: InfoPage[];
}

export interface UpdateInfoPageRequest {
  id: string;
  title: string;
  content: string;
  language: string;
}

@Injectable({
  providedIn: 'root'
})
export class InfoPageService {
  private readonly baseUrl = `${environment.apiLocations.communication}/info-page`;

  constructor(private apiService: ApiService) {}

  getAllInfoPages(): Observable<BaseApiResponse<GetAllInfoPagesResponse>> {
    return this.apiService.get<GetAllInfoPagesResponse>(`${this.baseUrl}/getAllInfoPages`);
  }

  updateInfoPage(data: UpdateInfoPageRequest): Observable<BaseApiResponse<InfoPage>> {
    return this.apiService.post<InfoPage>(`${this.baseUrl}/updateInfoPage`, data);
  }
}
